import { AlbumFile } from '@/models/albumFile.ts'
import { CropData } from '@/types/photoCrop.ts'
import { ImageCropCard } from './ImageCropCard.tsx'

interface PhotoCropListProps {
  selectedImages: AlbumFile[]
  cropData: CropData
  getAspectRatio: (rotated: boolean) => number
  updateCrop: (imageId: string, crop: { x: number; y: number; width: number; height: number }) => void
  updateCount: (imageId: string, delta: number) => void
  toggleRotation: (imageId: string) => void
  removeImage: (imageId: string) => void
  isEditingExisting?: boolean
  disableRotation?: boolean
}

export function PhotoCropList({
  selectedImages,
  cropData,
  getAspectRatio,
  updateCrop,
  updateCount,
  toggleRotation,
  removeImage,
  isEditingExisting = false,
  disableRotation = false
}: PhotoCropListProps) {
  return (
    <div className="space-y-8 mb-6">
      {selectedImages.map((image, index) => (
        <ImageCropCard
          key={image.id}
          image={image}
          index={index}
          cropData={cropData[image.id]}
          aspectRatio={getAspectRatio(cropData[image.id]?.rotated)}
          onCropChange={(crop) => updateCrop(image.id, crop)}
          onCountChange={(delta) => updateCount(image.id, delta)}
          onToggleRotation={() => toggleRotation(image.id)}
          onRemove={() => removeImage(image.id)}
          isEditingExisting={isEditingExisting}
          disableRotation={disableRotation}
        />
      ))}
    </div>
  )
}